const l = {
  name: "StarCircle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M23.7,16.1L20,8.8l-3.7,7.3L9,17.3l5.4,6l-1.8,7.6l7.4-3.7l7.5,3.7l-1.9-7.6l5.4-6L23.7,16.1z M17.7,17.9
	l2.3-4.7l2.3,4.7l4.7,0.8l-3.6,4l1.1,4.4L20,24.9l-4.4,2.3l1-4.4l-3.6-4L17.7,17.9z"/>
<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
	s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
</svg>
  `
};
export {
  l as StarCircle
};
